import { render, staticRenderFns } from "./SalesOrderReport.vue?vue&type=template&id=23e738ba&"
import script from "./SalesOrderReport.vue?vue&type=script&lang=ts&"
export * from "./SalesOrderReport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23e738ba')) {
      api.createRecord('23e738ba', component.options)
    } else {
      api.reload('23e738ba', component.options)
    }
    module.hot.accept("./SalesOrderReport.vue?vue&type=template&id=23e738ba&", function () {
      api.rerender('23e738ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sales/reports/SalesOrderReport.vue"
export default component.exports